/**
 * @file: DeviceMegboxFlow.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 旷世魔方设备客流量统计
 */
import request from '@/utils/request'

/**
 * megbox hhtp警戒类抓拍上报(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function megboxDevicemegboxflowHttpReport(data) {
  return request({
    type: 'device',
    url: 'megbox/deviceMegboxFlow/http/report',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/DeviceMegboxFlow.js